import * as Network from 'expo-network'

// See docs here: https://docs.expo.dev/versions/latest/sdk/network/#installation

export const isConnectedToNetwork = async () => {
    const network_state = await Network.getNetworkStateAsync()
    //return network_state.isConnected // use for no connection at all
    return network_state.isInternetReachable // use for bad connection
}
